import { Product } from "@deliverr/commons-clients";
import { StorageInboundProductItem } from "../create/store/StorageInboundProductItem.types";

type IsTotalUnitsEmptyValidator = (product: Partial<StorageInboundProductItem & Product>[]) => boolean;

export const isTotalUnitsEmpty: IsTotalUnitsEmptyValidator = (products) =>
  products.some((val) => !val.caseQty || !val.numberOfCases);
